export const termsOfService = `출정 이용약관제1조 목적 
본 이용 약관은 “다정북스”(이하 "회사")가 제공하는 “웹사이트” (이하 “서비스”)의 이용 조건과 운영에 관한 제반 사항 규정을 목적으로 합니다. 

 제2조 용어의 정의
 1. 본 약관에서 사용되는 주요한 용어의 정의는 다음과 같습니다.
 가. “서비스”란 회사가 디지털 콘텐츠 및 상품 등을 공급하는 웹사이트, 모바일 어플리케이션 등의 플랫폼을 말합니다.
 나. “이용자” 또는 “회원”이란 회사가 제공하는 서비스에 가입하여 서비스를 이용하는 자를 말합니다.
 다. "유료회원"이란 회원 중 회사에 일정 금액을 납부하고 유료서비스를 이용하는 자를 말합니다.
 라. “환불”이란 이용자가 결제한 금액을 규정에 따라 되돌려 받는 것을 말합니다.
 마. “탈퇴”란 이용자가 서비스 이용 계약을 종료하는 의사표시를 말합니다.

 2. 이 약관에서 사용하는 용어의 정의는 제 1 항에서 정하는 것을 제외하고는 관계 법령에서 정하는 바를 따릅니다.
 
 
 제3조 약관의 효력과 변경
 1. 회사는 서비스의 초기화면에 이 약관을 명시합니다.
 2. 이 약관은 이용자가 서비스를 이용함과 동시에 효력이 발생하며, 이 약관에 동의하지 않을 경우 이용자는 서비스 이용계약을 철회할 수 있습니다.
 3. 회사는 이 약관을 관련 법령에 위배되지 않는 범위에서 변경할 수 있습니다.
 4. 변경된 약관은 적용일 및 변경내용, 변경사유 등을 명시하여 적용일 15일 이전(다만, 이용자에게 불리한 약관의 개정의 경우에는 적용일 30일 이전)부터 적용일 전일까지 서비스에 고지한 후 적용일부터 효력이 발생됩니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소 30일 이전에 유예기간을 두고 개별 통지합니다.
 5. 이용자는 변경된 약관에 동의하지 않을 권리가 있으며, 변경된 약관에 동의하지 않을 경우에는 서비스 이용을 중단하고 탈퇴할 수 있습니다.
 6. 변경된 약관 공지 시 이용자가 회사에 명시적으로 "거부"의 의사표시를 하지 않거나 또는 이용자가 변경된 이용약관의 적용일 이후에도 서비스를 계속 사용하는 경우에는 변경된 약관에 동의한 것으로 간주합니다.
 
 
 제4조 약관 외 준칙
 운영자는 필요한 경우 별도로 운영정책을 공지 안내할 수 있으며, 본 약관과 운영정책이 중첩될 경우 운영정책이 우선 적용됩니다.
 
 
 제5조 이용계약 체결
 1. 서비스 이용계약은 서비스를 이용하려는 자가 본 약관에 동의하고 서비스를 이용함으로써 성립됩니다.
 2. 연령에 따라 일부 서비스에 대하여 이용이 제한될 수 있습니다.
 
 
 제6조 서비스 이용 신청
 1. 이용자는 회사가 제공하는 방식을 통해 서비스에 가입할 수 있습니다.
 2. 회사는 서비스에 가입한 이용자에게 닉네임, 고유아이디가 포함된 계정을 제공합니다.
 3. 회사는 계정 정보를 통해 학습 정보 확인 등의 이용자 관리업무를 수행합니다.
 4. 이용자는 자신의 계정을 성실히 관리하여야 합니다. 이용자가 본인의 계정을 소홀히 관리하거나 제 3자에게 이용을 승낙함으로써 발생하는 손해에 대하여는 이용자에게 책임이 있습니다.
 
 
 제7조 회원정보의 관리
 1. 회원은 회원 가입 신청 시에 기입한 사항이 변경되었을 경우에는 즉시 기본서비스에서 변경사항을 최신의 정보로 수정하여야 합니다. 단, 아이디, 생년월일, 실명은 변경할 수 없습니다.
 2. 변경된 사항을 반영하지 않음으로 인하여 발생하는 손해 및 법 위반 책임은 당해 회원이 전적으로 부담하며, 회사는 이에 대하여 아무런 책임을 지지 않습니다.
 3. 아이디, 비밀번호에 대한 관리책임은 전적으로 회원에게 있으며, 회원은 아이디, 비밀번호를 타인에게 양도, 대여할 수 없습니다.
 4. 회사는 귀책사유 없는 아이디, 비밀번호의 유출, 양도, 대여로 인한 손실이나 손해에 대하여 아무런 책임을 지지 않습니다.
 5. 회원은 회원의 아이디, 비밀번호가 도용되거나 제3자가 무단 사용하고 있음을 인지한 경우, 지체 없이 회사에 통지하여야 하고, 회사의 안내가 있는 경우에는 그에 따라야 합니다. 회원이 회사에 이를 지체 없이 통지하지 않거나 통지한 경우에도 회사의 안내에 따르지 않은 경우에는 도용 또는 제3자의 무단 사용으로 인한 손실이나 손해에 대하여 회사는 아무런 책임을 지지 않습니다.
 6. 계정 관리 책임은 회원 개인에게 있으며, 회원은 어떠한 경우에도 본인의 계정을 타인에게 양도하거나 타인으로 하여금 이용하게 하거나 타인의 기본서비스 이용을 위해서 사용하면 안 됩니다.
 7. 회원은 복수의 아이디를 보유할 수 없습니다.
 
 
 제8조 계약 해지와 이용 중지 요청
 1. 회원은 언제든지 기본서비스 내 정해진 절차를 거쳐 기본서비스 이용계약 해지 또는 이용 중지를 신청할 수 있으며 회사는 이를 즉시 처리합니다.
 2. 해지로 인하여 회원에게 발생하는 손해에 대하여 회사는 책임지지 않습니다.
 3. 이용자는 계정 탈퇴 완료 이후에 서비스에 재가입이 가능합니다.
 
 
 제9조 회원의 의무
 1. 이용자는 서비스를 본래의 이용 목적 이외의 용도로 사용하거나 다음 각 호에 해당하는 행위를 해서는 안되며, 아래의 항을 위반하는 것으로 의심되는 이용자를 발견할 시 이메일, ‘신고하기’ 등을 통해 신고를 접수하여야 합니다.
 가. 다른 이용자의 계정 혹은 타인의 결제 정보를 도용하거나 회사의 관리자를 사칭하는 행위
 나. 서비스 이용 중 허위 사실을 기재하여 서비스 운영을 방해하는 행위
 다. 회사가 제공한 계정 및 유료 참여 링크를 타인에게 양도하는 행위
 라. 회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙없이 복제, 유통하여 상업적으로 이용하는 행위
 마. 사기성, 음란성, 사행성, 혐오성 메시지 혹은 음성 등이 담긴 콘텐츠를 방송하거나 게시하는 행위
 바. 타인의 명예를 훼손하거나 사이버 불링, 폭력적인 행위를 하는 등 다른 이용자의 정상적인 서비스 이용을 방해하는 행위
 사. 저작권을 포함한 지적재산권, 초상권 등 회사 및 제 3자의 기타 권리를 침해하는 행위
 아. 타인의 개인정보를 동의없이 수집, 저장, 유포, 게시하는 행위
 자. 일반적이지 않은 방식으로 데이터를 조작하여 회사의 서비스 운영을 방해하는 행위
 차. 컴퓨터 소프트웨어, 하드웨어, 전기 통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 전송, 게시, 유포, 사용하는 행위
 카. 서버 해킹, 데이터 유출, 버그 등을 통해 서비스를 변경하거나 회사가 정하지 않은 방식으로 서비스를 이용하는 행위
 타. 관계 법령, 서비스 이용약관, 운영정책, 공지사항을 위배하는 행위
 파. 기타 공공질서 및 미풍양속을 위반하거나 불법적, 부당한 방식의 행동을 하는 행위
 2. 회사는 이용자가 제 1 항에 정한 서비스 이용 제한 기준을 위반하여 회사의 서비스에 지장을 초래한 경우, 사전 통보 없이 해당 행위자의 서비스 이용을 제한하고 손히배상을 청구할 수 있습니다 .
 
 
 제10조 게시물의 저작권
 1. 서비스 또는 기타 회사가 운영하는 정보통신망에 게시된 내용에 대한 저작권은 모두 회사에게 귀속됩니다.
 2. 회사 또는 서비스의 상표, 로고 등 식별지, 기본 서비스의 일체의 콘텐츠에 관한 지적재산권 등의 권리는 회사에 귀속합니다.
 3. 회원이 서비스에 게시한 게시물에 대한 책임은 게시자 본인에게 있으며, 회원이 기본 서비스에 게시한 정보나 의견은 회사의 입장과는 무관합니다. 회사는 회원이 서비스에 게재한 각종 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 대하여 책임을 지지 않습니다.
 4 회원이 서비스에 게시한 게시물로 파생되는 문제에 대해서는 전적으로 해당 게시물을 게시한 회원에게 책임이 있습니다.
 5. 회원은 회사의 사전 승낙 없이 자신의 작성 게시물을 제외한 게시물의 내용을 복제, 배포, 전송하거나 사용하거나 제3자로 하여금 사용하게 해서는 아니 됩니다. 회원의 작성 게시물은 회사의 기본 서비스 운영, 개선, 홍보, 프로모션, 마케팅, 판촉 등을 위하여 임의의 정보통신망에 복제, 배포, 전송, 게시, 노출될 수 있으며, 본질적인 내용에 변경을 가하지 않는 범위 내에서 수정, 편집될 수 있습니다.
 6. 회사는 회원이 작성한 게시물이 관련 법령에 위반되거나 음란 또는 청소년에게 유해한 게시물, 차별 갈등을 조장하는 게시물, 도배 · 광고 · 홍보 · 스팸성 게시물, 계정을 양도 또는 거래하는 내용의 게시물, 타인을 사칭하는 게시물, 타인의 권리를 침해하는 게시물 등이라고 판단되는 경우 이를 삭제하거나 게시를 거부할 수 있습니다.
 7. 회사는 회사의 게시물 정책에 따른 기간이 경과한 게시물을 임의로 삭제하거나 게시를 차단할 수 있습니다.
 8. 회사는 Zoom, Discord, Google Meets 및 기타 유사한 기능을 제공하는 외부 솔루션을 통한 학습 화면 등 회사가 제공하는 서비스를 이용자가 사용하는 경우 마케팅, 홍보 등 관련 서비스 목적으로 사용할 수 있습니다.
 9. 제5항의 사용범위는 이용자가 서비스 내에 게시한 콘텐츠의 복제, 수정, 전시, 전송, 배포, 출판 및 2차 저작물과 편집 저작물 작성을 포함합니다.
 
 
 제11조 서비스 이용 시간
 1. 회사는 업무상 또는 기술상 특별한 지장이 없는 한 1 일 24 시간 서비스를 제공합니다.
 2. 회사는 시스템 정기점검(서비스, 강의, 서버, Zoom, Discord, Google Meets 및 기타 유사한 기능을 제공하는 외부 솔루션 포함) 등 서비스 운영상 필요한 경우, 일정기간 동안 서비스를 일시 중지시킬 수 있으며, 이러한 경우 회사는 그 내용 및 시간을 서비스 내에 공지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
 3. 회사는 새로운 서비스, 각종 버그 패치(서비스, 강의, 서버, Zoom, Discord, Google Meets 및 기타 유사한 기능을 제공하는 외부 솔루션 포함) 등 서비스 운영 또는 기술상 필요한 경우에는 제공하고 있는 서비스의 전부 또는 일부를 수정, 추가, 폐지 등 변경할 수 있습니다. 변경될 서비스의 내용 및 일자 등에 대해서는 사전에 서비스 내에 공지함으로써 이용자에 대한 통지를 대체합니다.
 4. 회사는 서비스의 기획이나 운영상 또는 회사의 긴박한 상황 등에 의해 서비스 전부를 중단할 필요가 있는 경우 서비스 내에 이를 사전에 공지하고 서비스의 제공을 중단할 수 있습니다. 단, 회사가 통제할 수 없는 사유로 인한 경우 공지없이 서비스가 중단될 수 있습니다.
 
 
 제 12조 광고의 게재
 1. 회사는 본 서비스를 유지하기 위하여 서비스 내에 광고를 게재할 수 있습니다.
 2. 서비스에 게재되는 제 3 자가 주체인 광고에 이용자가 참여하거나 거래함으로써 발생하는 손실과 손해에 대해서 회사는 어떠한 책임도 부담하지 않습니다.
 
 
 
 제 14조 구매 및 유효기간
 1. 이용자는 결제 사업자의 결제 정책에 따라 서비스 또는 강의 상품을 구매할 수 있습니다. 이 경우, 결제 사업자의 결제 정책에 따라 결제 금액에 차이가 발생할 수 있습니다.
 2. 이용자는 구매한 서비스 또는 강의 상품을 이용자 본인의 계정에서만 이용할 수 있으며, 제 3 자에게 양도, 대여, 매매할 수 없습니다.
 
 
 제 15조 구매 취소
 1. 이용자가 구매한 서비스 또는 강의 상품은 회사가 정한 환불/취소 규정에 따라 구매 취소가 가능합니다.
 2. 회사는 구매 취소 신청자로부터 제공받은 개인 정보 및 구매 내역을 확인하여 구매 취소를 진행합니다. 회사는 이용자의 정당한 구매 취소 사유를 확인하기 위해 추가 증빙자료를 요구할 수 있습니다. (예. 플랫폼사업자에 등록된 개인정보, 결제 사업자의 구매 또는 결제 내역, 고객의 의도와 상이하게 타인을 통해 구매되었다는 것을 확인할 수 있는 서류(가족관계 증명) 등)
 3. 다음 각 호의 경우 서비스 상품의 구매 취소가 제한될 수 있습니다.
 가. 구매 후 14일이 지난 서비스 또는 강의 상품의 경우
 나. 구매 후 서비스 또는 강의 상품이 이용된 경우
 다. 이벤트, 광고, 보상 등 무상으로 제공받은 서비스 또는 강의 상품의 경우
 라. 구매자의 악의적 상품 이용으로 회사의 손해가 발생한 경우
 마. 소비자의 잘못으로 상품이 멸실 (물건의 기능을 할 수 없을 정도로 전부 파괴된 상태) 되거나 훼손 된 경우
 바. 소비자의 사용, 포장 개봉 등에 의해 상품 등의 가치가 현저히 감소한 경우
 사. 시간이 지나 다시 판매하기 곤란할 정도로 물건의 가치가 뚜렷하게 떨어진 경우
 아. 복제가 가능한 물건의 포장을 훼손한 경우
 자. 세트 상품 일부만 반품하려 하는 경우 (반품을 희망하는 경우, 세트 상품은 전체를 반품)
 차. 디지털 컨텐츠인 eBook, 오디오북, 부록 강의 등을 1회 이상 다운로드 받았거나 웹뷰어로 보기 혹은 듣기를 한 경우
 
 
 제 17조 환불

1. 회원은 서비스 결제일로부터 7일 이내에 청약 철회를 요청할 수 있습니다. 단, 결제 후 서비스를 단 1회라도 이용한 경우(로그인, 콘텐츠 조회, 자료 다운로드 등 포함), 전자상거래 등에서의 소비자보호에 관한 법률 제17조 제2항 제5호(디지털 콘텐츠의 제공이 개시된 경우)에 따라 청약 철회(환불)가 제한됩니다.
2. 서비스를 이용한 내역이 없는 상태에서 7일 이내 청약 철회를 요청하는 경우, 결제 금액 전액을 환불합니다.
3. 제1항의 청약 철회 기간(7일)이 경과하였거나 서비스를 이미 이용한 경우, 회원은 언제든지 구독 '해지'를 신청할 수 있습니다. 이 경우 환불은 발생하지 않으며, 구독은 현재 이용 주기가 만료되는 시점에 종료되고 다음 결제일에 요금이 청구되지 않습니다.
4. 회원의 귀책 사유로 이용약관을 위반하여 계약이 해지되는 경우, 환불이 불가합니다.

 
 
 제 18조 손해배상
 1. 이용자가 이 약관에서 정한 사항을 위반함으로써 회사 또는 제 3 자에게 손해를 입힌 경우 이용자는 회사 또는 제 3 자에게 그 손해를 배상하여야 합니다.
 
 
 제 19조 책임제한
 1. 회사는 서비스 또는 강의 이용장애 혹은 서비스 또는 강의가 변경되거나 중지된 원인이 회사의 고의 또는 중과실로 인한 경우를 제외하고는 서비스 또는 강의 이용장애, 변경 및 중지로 인하여 이용자에게 발생하는 손해에 대해서는 책임이 면제됩니다.
 2. 회사는 이용자가 본인의 개인정보 등(계정 포함)을 변경하여 얻는 불이익 및 정보 상실에 대해서는 책임이 면제됩니다.
 3. 회사는 이용자 상호간 또는 이용자와 제 3 자 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.
 
 
 제 20조 약관 외 준칙
 1. 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 「전자상거래법」, 「약관 규제법」, 「정보통신망법」, 「콘텐츠산업진흥법」, 「학원의 설립·운영 및 과외교습에 관한 법률」, 「학원의 설립·운영 및 과외교습에 관한 법률 시행령」 등 관계 법령에 따릅니다.
 2. 회사는 본 약관 외에 운영정책, 개인정보처리방침 등 개별 약관을 둘 수 있습니다.
 
 
 제 21조 재판권 및 준거법
 1. 회사와 이용자간에 제기된 소송에는 대한민국 법을 적용합니다.
 2. 서비스 이용과 관련하여 회사와 이용자간에 발생한 분쟁에 대해서는 서울중앙지방법원을 합의관할로 합니다.
`;

export const privacyPolicy = `출정 개인정보처리방침
개인정보처리방침

'다정북스' (이하 '회사')은(는) 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』(이하 “정보통신망법”), 『개인정보 보호법』 등 관련 법령상의 개인정보 보호규정을 준수하며, 정보통신망법에 의거한 개인정보처리방침을 정하여 이용자 권익보호에 최선을 다하고 있습니다. 본 개인정보처리방침은 회사가 제공하는 웹 / 모바일웹 서비스에 적용되며 다음과 같은 내용을 포함하고 있습니다. 회사는 개인정보 처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
 
 ○ 본 방침은 2025년 11월 1일부터 시행됩니다.
 
 1. 수집하는 개인정보 항목
 회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
 1.1. 수집항목
 <개인회원>
 - 필수항목: 이름, 이메일, 전화번호, 배송지, 생년월일, 비밀번호, 주소, 휴대폰 번호, 암호화된 이용자 확인값(CI)
 - 선택항목: (정부 연계 과목 신청 시) 주민등록번호, 본인인증기록
 서비스 이용과정에서 IP주소, 쿠키, 방문일시, 서비스 이용기록과 같은 정보가 자동으로 생성되어 수집될 수 있습니다.
 
 1.2. 수집 방법
 - 홈페이지 회원가입
 - 전화, 팩스, 상담게시판을 통한 고객상담 및 서비스 이용관리
 - 이벤트(경품행사) 응모, 배송요청
 - 생성정보 수집툴을 통한 수집
 
 
 
 2. 개인정보의 수집 및 이용목적
 회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
 
 2.1. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금 정산 콘텐츠 제공, 구매 및 요금 결제, 물품 배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융 서비스, 요금 추심
 
 2.2. 회원 관리 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령 확인, 불만 처리 등 민원처리, 고지사항 전달
 
 2.3. 마케팅 및 광고에 활용 신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계
 
 회원 가입 및 회원 관리
 [회원 관리] (회원 탈퇴시 까지)
 - 회원제 서비스 이용에 따른 본인확인을 통한 회원 식별
 - 중복 회원가입 횟수 제한
 - 필수 : 아이디, 비밀번호, 이름, 본인인증정보 (이메일 주소)
 자동 : 자동수집정보: 서비스이용기록, 이용정지기록, 이용해지 기록, IP 주소, 접속로그, 쿠키(cookie)
 - 선택 : 성별, 전화번호, 본인인증 이외의 휴대전화 또는 이메일 주소, 학교명 (학생회원일 경우), 성적정보, 진학정보, 학년, 계열(스터디클럽 참여 시), 주소
 
 [회원 관리] (회원 탈퇴시 까지)
 - 불량 회원의 부정 이용 방지와 비인가 사용 방지
 - 고지사항전달
 - 필수 : 아이디, 비밀번호, 이름, 생년월일, 본인인증정보 (휴대전화번호 또는 이메일 주소 중 선택)
 
 [고객 상담] (3년)
 - 분쟁 조정을 위한 기록보존
 - 불만처리, 민원처리, 고객상담
 - 필수 : 이름(보호자, 학생), 휴대전화번호(보호자, 학생), 이메일 주소, 전화번호, 학년, 계열
 
 [계약이행 및 서비스 제공] (5년)
 - 서비스 및 콘텐츠 제공
 - 구매 및 요금 결제
 - 콘텐츠 구매에 대한 본인인증
 - 우편발송, 물품배송 또는 청구서 등
 - 맞춤형 입시분석 및 진학자료 제공
 - 필수 : 이름, 연락처, 주소, 이메일, 결제수단, 은행명, 계좌번호, 입금자명, 신용카드 종류, 요금청구 및 결제 기록
 - 선택 : 현금영수증 발급정보(휴대전화번호)
 
 [마케팅 및 광고] (목적 달성시 까지)
 - 신규 서비스 또는 제품의 개발 및 특화
 - 웹페이지 접속 빈도 파악
 - 상품/서비스의 이용실적 분석
 - 서비스 및 상품 안내
 - 이벤트 등 광고성 정보 전달
 - 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계
 - 고객대상 설문조사
 - 경품행사, 이벤트 등 광고성 정보 전달 또는 회원 참여공간 운영
 - 고객 관심사에 부합하는 웹서비스 및 이벤트 기획
 - 선택 : 이름, 휴대전화번호, 생년월일, 입시정보, 사진, 학교정보 등
 
 
 
 3. 개인정보의 보유 및 이용 기간
 원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.

 3.1. 회사 내부 방침에 의한 보존 불량 이용자의 재가입 방지, 명예훼손 등 권리침해 분쟁 및 수사 협조 : 회원 탈퇴 후 1년

 3.2. 관련 법령에 의한 보존 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계 법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계 법령에서 정한 일정한 기간 동안 회원 정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
 - 계약 또는 청약 철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
 - 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
 - 소비자의 불만 또는 분쟁 처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)
 - 표시/광고에 관한 기록 : 6개월 (전자상거래 등에서의 소비자보호에 관한 법률)
 
 
 
 4. 개인정보의 파기절차 및 방법
 회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기 절차 및 방법은 다음과 같습니다.

 4.1. 파기 절차 회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용 기간 참조) 일정 기간 저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.

 4.2. 파기 방법
 - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
 - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
5. 개인정보의 제 3자 제공 회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
 - 이용자들이 사전에 동의한 경우
 - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
 - 회사는 원활한 서비스 제공과 효과적인 업무처리를 위하여 다음과 같이 개인정보를 처리 위탁하고 있습니다.
 - 회사는 수탁자들이 위탁한 개인정보를 안전하게 처리하고 있는지 지속적으로 관리 감독하고 있으며, 수탁업무가 종료된 때에 수탁자가 보유하고 있는 개인정보는 즉시 파기하게 하고 있습니다.
 
 
 
 6. 개인정보 처리위탁
 6.1 회사는 결제처리 등 서비스 제공을 위해 필요한 최소한의 업무를 전문업체에 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항들을 규정하고 있습니다.
 
- 수탁업체 : latpeed
 - 위탁업무 내용 : 결제 관리, SMS발송, 카카오 알림톡 발송

 - 수탁업체 : (주)채널코퍼레이션
 - 위탁업무 내용 : 채널톡 시스템 운영


 6.2 회사는 위탁계약 체결시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개인정보처리금지, 기술적관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리감독, 손해배상 등 책임에 대한 사항을 게약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.

 6.3 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
 
 
 
7. 이용자 및 법정대리인의 권리와 그 행사 방법
 이용자 및 법정대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입 해지를 요청할 수도 있습니다.

 이용자 혹은 만 14세 미만 아동의 개인정보를 조회/수정하기 위해서는 ‘개인정보 변경’(또는 ‘회원 정보수정’ 등)을, 가입 해지(동의 철회)를 위해서는 '회원 탈퇴'를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.

 혹은 개인정보 관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.

 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한, 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.

 회사는 이용자 혹은 법정대리인의 요청에 의해 해지 또는 삭제된 개인정보는 회사가 수집하는 '개인정보의 보유 및 이용 기간'에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
 
 
 
8. 개인정보의 안정성 확보조치에 관한 사항
 회사는 개인정보의 안정성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
 - 관리적 조치 : 내부관리계획 수립시행, 전담조직 운영, 정기적인 직원 교육
 - 기술적 조치 : 개인인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신
 - 물리적조치 : 전산실, 자료보관실 등의 접근통제
9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항 회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다

 9.1. 쿠키 등 사용 목적
 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.

 9.2. 쿠키 설정 거부 방법 귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.

 9.3. 쿠키 설정 거부 방법 예시 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.
 - Internet Explorer : 도구 메뉴 > 인터넷 옵션 > 개인정보 탭 > 개인정보처리 수준 설정
 - Chrome : 설정 메뉴 > 고급 설정 표시 선택 > 개인정보-콘텐츠 설정 > 쿠키 수준 설정
 - Firefox : 옵션 메뉴 > 개인정보 > 방문기록 -사용자 정의 설정 > 쿠키 수준 설정
 - Safari : 환경설정 메뉴 > 개인정보 탭 > 쿠키 및 웹 사이트 데이터 수준 설정

 9.4 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
 

 
 10. 권익침해 구제 방법
 개인정보 주체는 개인정보 침해로 인한 구제를 받기 위하여 개인정보 분쟁조정위원회, 한국인터넷진흥원의 개인정보 침해신고센터 등에 분쟁 해결이나 상담 등을 신청할 수 있습니다. 이 밖에 개인정보 침해의 신고 및 상담에 대하여는 아래 기관에 문의하시기 바랍니다.
 - 개인정보분쟁조정위원회 : (국번없이) 1833-6972 ([www.kopico.go.kr](http://www.kopico.go.kr/))
 - 개인정보침해신고센터 : (국번없이) 118 ([privacy.kisa.or.kr](http://privacy.kisa.or.kr/))
 - 대검찰청 : (국번없이) 1301 ([www.spo.go.kr](http://www.spo.go.kr/))
 - 경찰청 : (국번없이) 182 ([ecrm.cyber.go.kr](http://ecrm.cyber.go.kr/))
 
 
 
11. 개인정보 관리 책임자 및 담당자의 연락처
 귀하께서는 회사의 서비스를 이용하시면서 발생하는 모든 개인정보 보호 관련 민원을 개인정보 관리 담당자 혹은 개인정보 관리 책임자에게 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 답변을 드릴 것입니다.
 개인정보보호 담당부서 : 운영 (개인정보보호 담당부서에서 개인정보 열람청구 업무를 담당합니다.)
 연락처 : [dajeongmath@naver.com]
 ※ 개인정보 보호 담당부서로 연결됩니다.
 
 
 
12. 개인정보 처리방침의 변경에 관한 사항
 12.1 이 개인정보 처리방침은 2024. 11. 1. 부터 적용됩니다.

 12.2 고지의 의무 개인정보 취급/처리 방침에 대한 내용의 변경이 있을 시에는 시행 최소 7일 전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다

 12.3 이전의 개인정보 처리방침은 아래에서 확인할 수 있습니다.
`;
